/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { dateFormatsMap } from '../constants/localeFormats';

export const getDateFormatByLocale = (locale: string): string => {
  return dateFormatsMap[locale] || dateFormatsMap.__fallback;
};
